import { render, staticRenderFns } from "./copyChargeDialog.vue?vue&type=template&id=2a267e6c&scoped=true&"
import script from "./copyChargeDialog.vue?vue&type=script&lang=js&"
export * from "./copyChargeDialog.vue?vue&type=script&lang=js&"
import style0 from "./copyChargeDialog.vue?vue&type=style&index=0&id=2a267e6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a267e6c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a267e6c')) {
      api.createRecord('2a267e6c', component.options)
    } else {
      api.reload('2a267e6c', component.options)
    }
    module.hot.accept("./copyChargeDialog.vue?vue&type=template&id=2a267e6c&scoped=true&", function () {
      api.rerender('2a267e6c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SeaExport/components/booking/copyChargeDialog.vue"
export default component.exports